module.exports = __webpack_public_path__ + "static/media/google-plus-square.d0e27cdf.svg";